import { Link } from "react-router-dom";


import { Button } from "../components/ui/button";
import { Label } from "@radix-ui/react-label";

export default function NotFoundPage() {
  return (
    <section className="page-padding grid h-full place-items-center">
      <div className="container-safe text-center">
        <h1 className="page-heading">404 | Page not found</h1>
        <Label className="mt-12 text-2xl">Looks like this page doesn’t exist.</Label>
        <p>&nbsp;</p>
        <Link to="/" >
          <Button size="large">Go Home</Button>
        </Link>
      </div>
    </section>
  );
}
